import React from 'react';
import { Link } from 'react-router-dom';
import { func, object } from 'prop-types';
import Icon from '../Icon/Icon';
import { createMarkup } from '../../utils/utils';
import { FormattedMessage } from 'react-intl';

const propTypes = {
  params: object.isRequired,
  onClose: func,
};

const defaultProps = {
  params: {},
  onClose() {},
};

const CustomAlert = ({ params, onClose }) => {
  const { redirectPath, dismissable, message, alertType, closeInSeconds, redirectComponent } =
    params;

  const replaceMD = (message) => {
    return (
      <span
        dangerouslySetInnerHTML={createMarkup(
          message.replace(
            /(?:\[(.*)\])(?:\(([^\(]*)\))/g,
            '<a class="link" href="$2" target="_blank">$1</a>',
          ),
        )}
      />
    );
  };

  if (closeInSeconds) {
    setTimeout(onClose, closeInSeconds * 1000);
  }

  const msg = replaceMD(message);

  const renderMessage = () => {
    if (redirectComponent) {
      return redirectComponent;
    } else if (redirectPath) {
      return <Link to={redirectPath}>{msg}</Link>;
    } else {
      return msg;
    }
  };

  return (
    <div
      className={`alert-notification ${
        dismissable ? 'alert-notification-dismissable' : ''
      } alert-notification_${alertType}`}
      role="alert"
    >
      <div className="alert-notification-container container">
        <i className={`alert-notification-icon icon-alert-${alertType}`} />
        <div className="alert-notification-text">
          <span className="alert-notification-message">{renderMessage()}</span>
        </div>
        {dismissable && (
          <button
            className="alert-notification-button-dismiss"
            onClick={onClose}
            aria-label="Close alert"
            role="button"
          >
            <span className={'alert-notification-button-dismiss-close'}>Закрыть</span>
            <span className={'alert-notification-button-dismiss-close-mob'} />
          </button>
        )}
      </div>
    </div>
  );
};

CustomAlert.propTypes = propTypes;
CustomAlert.defaultProps = defaultProps;

export default CustomAlert;
